import { render, staticRenderFns } from "./ClaimsFormList.vue?vue&type=template&id=428ebeda"
import script from "./ClaimsFormList.vue?vue&type=script&lang=ts"
export * from "./ClaimsFormList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports